/* Timi of Sweden - Store Locator (Mapbox GL JS) */
(function () {
  'use strict';

  var MB_JS = 'https://api.mapbox.com/mapbox-gl-js/v3.9.0/mapbox-gl.js';
  var MB_CSS = 'https://api.mapbox.com/mapbox-gl-js/v3.9.0/mapbox-gl.css';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function haversine(a, b, c, d) {
    var R = 6371, p = Math.PI / 180;
    var dLat = (c - a) * p, dLon = (d - b) * p;
    var x = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(a * p) * Math.cos(c * p) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    return R * 2 * Math.atan2(Math.sqrt(x), Math.sqrt(1 - x));
  }

  function tel(p) { return String(p).replace(/[^\d+]/g, ''); }

  function directionsUrl(r) {
    var q = [r.address, r.postal, r.city, r.country].filter(Boolean).join(', ');
    return 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(q);
  }

  function pinEl() {
    var d = document.createElement('div');
    d.className = 'tsl__pin';
    d.innerHTML = '<svg width="26" height="34" viewBox="0 0 24 32" aria-hidden="true">' +
      '<path d="M12 0C5.9 0 1 4.9 1 11c0 8.2 11 21 11 21s11-12.8 11-21c0-6.1-4.9-11-11-11z" ' +
      'fill="#dd7e53" stroke="#ffffff" stroke-width="1.5"/>' +
      '<circle cx="12" cy="11" r="3.6" fill="#ffffff"/></svg>';
    return d;
  }

  function Locator(root) {
    this.root = root;
    this.dataUrl = root.dataset.dataUrl;
    this.token = root.dataset.token || '';
    this.styleUrl = root.dataset.style || 'mapbox://styles/mapbox/light-v11';
    this.homeCountry = (root.dataset.country || '').trim();
    this.labels = JSON.parse(root.dataset.labels || '{}');

    this.listEl = root.querySelector('[data-tsl-list]');
    this.countEl = root.querySelector('[data-tsl-count]');
    this.mapEl = root.querySelector('[data-tsl-map]');
    this.searchEl = root.querySelector('[data-tsl-search]');
    this.clearEl = root.querySelector('[data-tsl-clear]');
    this.countryEl = root.querySelector('[data-tsl-country]');
    this.nearEl = root.querySelector('[data-tsl-near]');
    this.noticeEl = root.querySelector('[data-tsl-notice]');

    this.all = []; this.view = []; this.markers = []; this.origin = null;
    this.bind(); this.load();
  }

  Locator.prototype.bind = function () {
    var self = this, t;
    this.searchEl.addEventListener('input', function () {
      clearTimeout(t);
      self.clearEl.classList.toggle('is-visible', !!this.value);
      t = setTimeout(function () { self.render(); }, 150);
    });
    this.clearEl.addEventListener('click', function () {
      self.searchEl.value = ''; self.clearEl.classList.remove('is-visible'); self.render();
    });
    this.countryEl.addEventListener('change', function () { self.render(true); });
    this.nearEl.addEventListener('click', function () { self.locate(); });
  };

  Locator.prototype.load = function () {
    var self = this;
    fetch(this.dataUrl, { credentials: 'omit' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        self.all = (d.retailers || []).filter(function (r) { return r.name && r.address; });
        self.buildCountries();
        self.render();
        self.initMap();
      })
      .catch(function () { self.notice(self.labels.error); });
  };

  Locator.prototype.buildCountries = function () {
    var seen = {}, list = [], byCc = {};
    this.all.forEach(function (r) {
      if (r.country && !seen[r.country]) {
        seen[r.country] = 1; list.push(r.country);
        if (r.cc) byCc[r.cc] = r.country;
      }
    });
    list.sort();
    var self = this;
    list.forEach(function (c) {
      var o = document.createElement('option');
      o.value = c; o.textContent = c;
      self.countryEl.appendChild(o);
    });
    if (this.homeCountry && byCc[this.homeCountry]) this.countryEl.value = byCc[this.homeCountry];
  };

  Locator.prototype.filtered = function () {
    var q = this.searchEl.value.trim().toLowerCase();
    var country = this.countryEl.value;
    var out = this.all.filter(function (r) {
      if (country && r.country !== country) return false;
      if (!q) return true;
      return (r.name + ' ' + r.city + ' ' + r.postal + ' ' + r.address + ' ' + r.country)
        .toLowerCase().indexOf(q) !== -1;
    });
    var o = this.origin;
    if (o) {
      out.forEach(function (r) {
        r._d = (r.lat != null) ? haversine(o.lat, o.lng, r.lat, r.lng) : Infinity;
      });
      out.sort(function (a, b) { return a._d - b._d; });
    } else {
      out.sort(function (a, b) { return a.name.localeCompare(b.name, 'sv'); });
    }
    return out;
  };

  Locator.prototype.render = function (refit) {
    this.view = this.filtered();
    this.countEl.textContent = this.view.length === 1
      ? this.labels.one
      : String(this.labels.many).replace('{n}', this.view.length);

    if (!this.view.length) {
      this.listEl.innerHTML = '<li class="tsl__empty">' + esc(this.labels.empty) + '</li>';
    } else {
      var self = this;
      this.listEl.innerHTML = this.view.map(function (r) {
        var dist = (r._d != null && isFinite(r._d))
          ? '<span class="tsl__dist">' + (r._d < 10 ? r._d.toFixed(1) : Math.round(r._d)) + ' km</span>' : '';
        var lines = [r.address, [r.postal, r.city].filter(Boolean).join(' '), r.country]
          .filter(Boolean).map(esc).join('<br>');
        var links = '<a class="tsl__link" href="' + directionsUrl(r) + '" target="_blank" rel="noopener">' +
          esc(self.labels.directions) + '</a>';
        if (r.phone) links += '<a class="tsl__link" href="tel:' + esc(tel(r.phone)) + '">' + esc(r.phone) + '</a>';
        if (r.website) links += '<a class="tsl__link" href="' + esc(r.website) + '" target="_blank" rel="noopener">' + esc(self.labels.website) + '</a>';
        return '<li><button type="button" class="tsl__item" data-id="' + esc(r.id) + '">' +
          '<span class="tsl__item-top"><span class="tsl__name">' + esc(r.name) + '</span>' + dist + '</span>' +
          '<span class="tsl__addr">' + lines + '</span>' +
          '<span class="tsl__links">' + links + '</span></button></li>';
      }).join('');

      var self2 = this;
      Array.prototype.forEach.call(this.listEl.querySelectorAll('.tsl__item'), function (btn) {
        btn.addEventListener('click', function (e) {
          if (e.target.closest('a')) return;
          self2.focus(btn.dataset.id, true);
        });
      });
    }
    this.drawMarkers(refit !== false);
  };

  Locator.prototype.initMap = function () {
    var self = this;
    if (!this.token) {
      this.notice(this.labels.nokey);
      this.mapEl.style.display = 'none';
      return;
    }
    if (!document.querySelector('link[data-tsl-mb]')) {
      var l = document.createElement('link');
      l.rel = 'stylesheet'; l.href = MB_CSS; l.setAttribute('data-tsl-mb', '1');
      document.head.appendChild(l);
    }
    if (window.mapboxgl) { this.onMapReady(); return; }
    var s = document.createElement('script');
    s.src = MB_JS;
    s.onload = function () { self.onMapReady(); };
    s.onerror = function () { self.notice(self.labels.nokey); };
    document.head.appendChild(s);
  };

  Locator.prototype.onMapReady = function () {
    var self = this;
    mapboxgl.accessToken = this.token;
    this.map = new mapboxgl.Map({
      container: this.mapEl,
      style: this.styleUrl,
      center: [12.0, 57.5],
      zoom: 3.6,
      cooperativeGestures: true,
      attributionControl: true
    });
    this.map.addControl(new mapboxgl.NavigationControl({ showCompass: false }), 'top-right');
    this.map.on('load', function () { self.drawMarkers(true); });
    this.map.on('error', function () { self.notice(self.labels.nokey); });
  };

  Locator.prototype.drawMarkers = function (fit) {
    if (!this.map) return;
    var self = this;
    this.markers.forEach(function (m) { m.remove(); });
    this.markers = [];
    var bounds = new mapboxgl.LngLatBounds(), any = false;

    this.view.forEach(function (r) {
      if (r.lat == null || r.lng == null) return;
      var m = new mapboxgl.Marker({ element: pinEl(), anchor: 'bottom' })
        .setLngLat([r.lng, r.lat])
        .addTo(self.map);
      m._id = r.id;
      m.getElement().addEventListener('click', function (e) {
        e.stopPropagation();
        self.focus(r.id, false);
      });
      self.markers.push(m);
      bounds.extend([r.lng, r.lat]);
      any = true;
    });

    if (this.origin) { bounds.extend([this.origin.lng, this.origin.lat]); any = true; }
    if (fit && any) this.map.fitBounds(bounds, { padding: 56, maxZoom: 13, duration: 600 });
  };

  Locator.prototype.focus = function (id, pan) {
    var r = null, i;
    for (i = 0; i < this.view.length; i++) if (String(this.view[i].id) === String(id)) r = this.view[i];
    if (!r) return;
    Array.prototype.forEach.call(this.listEl.querySelectorAll('.tsl__item'), function (b) {
      b.classList.toggle('is-active', b.dataset.id === String(id));
    });
    if (!this.map || r.lat == null) return;

    if (this.popup) this.popup.remove();
    var links = '<a href="' + directionsUrl(r) + '" target="_blank" rel="noopener">' + esc(this.labels.directions) + '</a>';
    if (r.phone) links += '<a href="tel:' + esc(tel(r.phone)) + '">' + esc(r.phone) + '</a>';
    this.popup = new mapboxgl.Popup({ offset: 30, closeButton: true, maxWidth: '260px' })
      .setLngLat([r.lng, r.lat])
      .setHTML('<div class="tsl-iw"><div class="tsl-iw__name">' + esc(r.name) + '</div>' +
        '<div class="tsl-iw__addr">' + esc(r.address) + '<br>' +
        esc([r.postal, r.city].filter(Boolean).join(' ')) + '</div>' +
        '<div class="tsl-iw__links">' + links + '</div></div>')
      .addTo(this.map);

    if (pan) this.map.flyTo({ center: [r.lng, r.lat], zoom: Math.max(this.map.getZoom(), 11), duration: 700 });
    else {
      var btn = this.listEl.querySelector('.tsl__item[data-id="' + String(id).replace(/"/g, '') + '"]');
      if (btn) btn.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  };

  Locator.prototype.locate = function () {
    var self = this;
    if (!navigator.geolocation) { this.notice(this.labels.nogeo); return; }
    this.nearEl.setAttribute('aria-busy', 'true');
    navigator.geolocation.getCurrentPosition(function (pos) {
      self.nearEl.removeAttribute('aria-busy');
      self.origin = { lat: pos.coords.latitude, lng: pos.coords.longitude };
      self.countryEl.value = '';
      self.render(true);
    }, function () {
      self.nearEl.removeAttribute('aria-busy');
      self.notice(self.labels.nogeo);
    }, { enableHighAccuracy: true, timeout: 8000, maximumAge: 300000 });
  };

  Locator.prototype.notice = function (msg) {
    if (!msg) return;
    this.noticeEl.textContent = msg;
    this.noticeEl.style.display = 'block';
  };

  document.addEventListener('DOMContentLoaded', function () {
    Array.prototype.forEach.call(document.querySelectorAll('[data-tsl-root]'), function (el) {
      new Locator(el);
    });
  });
})();
